(function () {
  function formatMoney(cents, format) {
    var centsValue = Number(cents) || 0;
    var value = centsValue / 100;
    var isWholeDollar = centsValue % 100 === 0;
    var withDecimals = value.toFixed(2);
    var noDecimals = String(Math.round(value));
    var template = format || '${{amount_no_decimals}}';

    var amount = isWholeDollar ? noDecimals : withDecimals;

    return template
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function formatMoneyFixed(cents, format) {
    var centsValue = Number(cents) || 0;
    var withDecimals = (centsValue / 100).toFixed(2);
    var template = format || '${{amount}}';

    return template
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
  }

  function perUnitCents(priceCents, unitCount) {
    var count = Math.max(1, Number(unitCount) || 1);
    return Math.floor(Number(priceCents) / count);
  }

  function getProductInfoFromNode(node) {
    return node?.closest('product-info');
  }

  function isOnetimeOnlySection(productInfo) {
    return productInfo?.hasAttribute('data-iw-onetime-only') || Boolean(productInfo?.querySelector('[data-iw-onetime-only]'));
  }

  function getPurchaseType(productInfo) {
    if (isOnetimeOnlySection(productInfo)) return 'onetime';

    var checked = productInfo?.querySelector('[data-iw-purchase-type] input:checked');
    if (checked) return checked.value;

    return (
      productInfo?.querySelector('[data-iw-purchase-type]')?.dataset.defaultPurchaseType ||
      'subscription'
    );
  }

  function isSubscriptionSelected(productInfo) {
    return getPurchaseType(productInfo) === 'subscription';
  }

  function getSelectedVariantInput(productInfo) {
    return productInfo?.querySelector('.iw-variant-card input:checked');
  }

  function getSellingPlanId(productInfo) {
    if (!productInfo || !isSubscriptionSelected(productInfo)) return '';

    var variantInput = getSelectedVariantInput(productInfo);
    var planId = variantInput?.dataset.sellingPlanId;

    if (!planId) {
      planId = getSelectedCard(productInfo)?.dataset.sellingPlanId || '';
    }

    if (planId) return planId;

    var form = getCartForm(productInfo);
    var iwInput = form?.querySelector('[data-iw-selling-plan-input]');
    return iwInput?.value || '';
  }

  window.iwGetSellingPlanId = getSellingPlanId;

  function getSelectedCard(productInfo) {
    return getSelectedVariantInput(productInfo)?.closest('.iw-variant-card');
  }

  function getCardPrice(card, purchaseType) {
    if (!card) return 0;
    if (purchaseType === 'subscription') {
      return Number(card.dataset.subscriptionPrice) || Number(card.dataset.onetimePrice) || 0;
    }
    return Number(card.dataset.onetimePrice) || 0;
  }

  function getCardCompare(card, purchaseType, price) {
    if (!card) return 0;
    var compare = Number(card.dataset.onetimeCompare);

    if (purchaseType === 'subscription') {
      if (!compare || compare <= price) {
        compare = Number(card.dataset.onetimePrice);
      }
    }

    if (!compare || compare <= price) return 0;
    return compare;
  }

  function getCartForm(productInfo) {
    var wrapper = productInfo?.querySelector('.product__info-wrapper');
    if (!wrapper) return null;

    var productForm = wrapper.querySelector('product-form.product-form');
    if (!productForm) return null;

    return (
      productForm.querySelector('form[data-type="add-to-cart-form"]') ||
      productForm.querySelector('form[action="/cart/add"]')
    );
  }

  function neutralizeForeignSellingPlanInputs(form) {
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      if (input.hasAttribute('data-iw-selling-plan-input')) return;

      input.disabled = true;
      input.checked = false;
      input.removeAttribute('name');

      if (form && input.form === form && input.parentNode) {
        input.parentNode.removeChild(input);
      }
    });
  }

  function disableAppstleSellingPlanInputs() {
    neutralizeForeignSellingPlanInputs();
  }

  function syncSellingPlanInput(productInfo, form) {
    form = form || getCartForm(productInfo);
    if (!form || !productInfo) return;

    neutralizeForeignSellingPlanInputs(form);

    var iwInput = form.querySelector('[data-iw-selling-plan-input]');
    var planId = getSellingPlanId(productInfo);

    if (!iwInput) {
      if (!planId) return;

      iwInput = document.createElement('input');
      iwInput.type = 'hidden';
      iwInput.name = 'selling_plan';
      iwInput.setAttribute('data-iw-selling-plan-input', '');
      form.appendChild(iwInput);
    }

    if (!isSubscriptionSelected(productInfo)) {
      iwInput.value = '';
      iwInput.disabled = true;
      return;
    }

    if (planId) {
      iwInput.disabled = false;
      iwInput.value = planId;
      return;
    }

    if (iwInput.value) {
      iwInput.disabled = false;
      return;
    }

    iwInput.value = '';
    iwInput.disabled = true;
  }

  window.iwSyncSellingPlan = syncSellingPlanInput;

  function updateCardPricing(card, purchaseType, moneyFormat) {
    if (!card) return;

    var price = getCardPrice(card, purchaseType);
    var compare = getCardCompare(card, purchaseType, price);
    var treatmentCount = card.dataset.treatment;
    var priceCents = perUnitCents(price, treatmentCount);
    var compareCents = compare ? perUnitCents(compare, treatmentCount) : 0;
    var cardsRoot = card.closest('[data-iw-variant-cards]');
    var perUnitLabel = cardsRoot?.dataset.perUnitLabel || 'treatment';

    var priceEl = card.querySelector('.iw-variant-card__price');
    var compareEl = card.querySelector('.iw-variant-card__compare');
    var perMonthEl = card.querySelector('.iw-variant-card__per-month');

    if (priceEl) priceEl.textContent = formatMoneyFixed(priceCents, moneyFormat);

    if (perMonthEl) {
      perMonthEl.textContent = perUnitLabel;
    }

    if (compareEl) {
      if (compare) {
        compareEl.textContent = formatMoneyFixed(compareCents, moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function updateAllCardPricing(productInfo) {
    var purchaseType = getPurchaseType(productInfo);
    var moneyFormat = productInfo.dataset.moneyFormat || '${{amount_no_decimals}}';

    productInfo.querySelectorAll('.iw-variant-card').forEach(function (card) {
      updateCardPricing(card, purchaseType, moneyFormat);
    });
  }

  function updatePurchaseTypeSelection(productInfo) {
    var purchaseType = getPurchaseType(productInfo);

    productInfo.querySelectorAll('.iw-purchase-type__option').forEach(function (option) {
      var input = option.querySelector('input[type="radio"]');
      var isSelected = input?.value === purchaseType;
      if (input) input.checked = isSelected;
      option.classList.toggle('is-selected', isSelected);
    });
  }

  function formatShipsEveryText(template, months) {
    var count = Math.max(1, Number(months) || 1);
    var monthWord = count > 1 ? 'months' : 'month';
    var text = (template || 'Ships every {month} month')
      .replace(/\{month\}/g, String(count))
      .replace(/\{month_word\}/g, monthWord);

    if (!/\{month_word\}/.test(template || '') && count > 1) {
      text = text.replace(/\smonth\b/i, ' months');
    }

    return text;
  }

  function updateFrequencyHeader(productInfo) {
    var header = productInfo.querySelector('[data-iw-frequency-header]');
    if (!header) return;

    if (isOnetimeOnlySection(productInfo) || getPurchaseType(productInfo) === 'onetime') {
      header.hidden = true;
      header.classList.add('is-hidden');
      return;
    }

    header.hidden = false;
    header.classList.remove('is-hidden');

    var selectedCard = getSelectedCard(productInfo);
    var months = selectedCard?.dataset.months || '1';
    var template = header.dataset.shipsTemplate || 'Ships every {month} month';
    var shipsEl = header.querySelector('[data-iw-frequency-ships]');

    if (shipsEl) {
      shipsEl.textContent = formatShipsEveryText(template, months);
    }
  }

  function updateAddToCartButton(productInfo) {
    if (!productInfo?.querySelector('[data-iw-purchase-type], [data-iw-selling-plan-input], .product-form__input--card')) return;

    var submitButtonText = productInfo.querySelector('.product-form__submit span');
    if (!submitButtonText) return;

    var submitButton = submitButtonText.closest('.product-form__submit');
    var purchaseType = getPurchaseType(productInfo);
    var selectedCard = getSelectedCard(productInfo);
    var price = getCardPrice(selectedCard, purchaseType);
    var moneyFormat = productInfo.dataset.moneyFormat || '${{amount_no_decimals}}';
    var addToCartLabel =
      productInfo.querySelector('[data-iw-add-to-cart-label]')?.dataset.iwAddToCartLabel ||
      window.variantStrings?.addToCart ||
      'Add to cart';

    if (selectedCard?.classList.contains('iw-variant-card--disabled')) {
      submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
      return;
    }

    var priceSpan = document.createElement('span');
    priceSpan.className = 'price-in-btn';
    priceSpan.textContent = '- ' + formatMoney(price, moneyFormat);
    submitButtonText.replaceChildren(document.createTextNode(addToCartLabel + ' '), priceSpan);
  }

  function ensureVariantSelected(productInfo) {
    if (getSelectedVariantInput(productInfo)) return;

    var cardsRoot = productInfo.querySelector('[data-iw-variant-cards]');
    var defaultIndex = Math.max(1, Number(cardsRoot?.dataset.defaultSelectedIndex) || 1);
    var allCards = Array.from(productInfo.querySelectorAll('.iw-variant-card'));
    var availableCards = allCards.filter(function (card) {
      return !card.classList.contains('iw-variant-card--disabled');
    });
    var targetCard = availableCards[defaultIndex - 1] || allCards[defaultIndex - 1] || availableCards[0];
    var input = targetCard?.querySelector('input[type="radio"]');
    if (input) input.checked = true;
  }

  function syncVariantIdInput(productInfo) {
    var form = getCartForm(productInfo);
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    var selectedCard = getSelectedCard(productInfo);
    var variantId = selectedCard?.dataset.variantId;

    if (!variantId) return;

    variantInput.value = variantId;

    var isUnavailable = selectedCard.classList.contains('iw-variant-card--disabled');
    variantInput.disabled = isUnavailable;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncSubmitButton(productInfo) {
    var submitButton = productInfo.querySelector('.product-form__submit');
    var selectedCard = getSelectedCard(productInfo);
    if (!submitButton || !selectedCard) return;

    submitButton.toggleAttribute('disabled', selectedCard.classList.contains('iw-variant-card--disabled'));
  }

  function syncVariantSelectsMetadata(productInfo) {
    if (!isOnetimeOnlySection(productInfo)) return;

    var variantSelects = productInfo.querySelector('variant-selects');
    var selectedCard = getSelectedCard(productInfo);
    if (!variantSelects || !selectedCard) return;

    var priceCents = getCardPrice(selectedCard, getPurchaseType(productInfo));
    variantSelects.dataset.selectedPriceAmount = (priceCents / 100).toFixed(2);

    var jsonScript = variantSelects.querySelector('[data-selected-variant]');
    if (!jsonScript || !selectedCard.dataset.variantId) return;

    try {
      var variant = JSON.parse(jsonScript.textContent);
      if (!variant || typeof variant !== 'object') return;

      variant.id = Number(selectedCard.dataset.variantId);
      if (typeof variant.price === 'number') variant.price = priceCents;
      jsonScript.textContent = JSON.stringify(variant);
    } catch (error) {
      // Ignore invalid JSON payloads.
    }
  }

  function bindLocalVariantInputs(productInfo) {
    if (!isOnetimeOnlySection(productInfo) && !productInfo.hasAttribute('data-iw-static-variants')) return;

    productInfo.querySelectorAll('.iw-variant-card input[type="radio"]').forEach(function (input) {
      if (input.dataset.iwLocalVariantBound === 'true') return;

      input.dataset.iwLocalVariantBound = 'true';
      input.addEventListener('change', function (event) {
        event.stopPropagation();
        refreshPurchaseState(productInfo);
      });
    });
  }

  function refreshPurchaseState(productInfo) {
    ensureVariantSelected(productInfo);
    updatePurchaseTypeSelection(productInfo);
    updateAllCardPricing(productInfo);
    updateFrequencyHeader(productInfo);
    syncVariantIdInput(productInfo);
    syncVariantSelectsMetadata(productInfo);
    syncSubmitButton(productInfo);
    syncSellingPlanInput(productInfo);
    updateAddToCartButton(productInfo);
    productInfo.dispatchEvent(
      new CustomEvent('iw:purchase-state-updated', { bubbles: true, detail: { productInfo: productInfo } })
    );
  }

  window.iwRefreshPurchaseState = refreshPurchaseState;

  function bindCartFormSubmit(productInfo) {
    var form = getCartForm(productInfo);
    if (!form || form.dataset.iwSellingPlanSubmitBound === 'true') return;

    form.dataset.iwSellingPlanSubmitBound = 'true';
    form.addEventListener(
      'submit',
      function () {
        syncSellingPlanInput(productInfo, form);
      },
      true
    );
  }

  function bindGlobalSubmit() {
    if (window.iwSellingPlanGlobalSubmitBound) return;
    window.iwSellingPlanGlobalSubmitBound = true;

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form?.matches?.('form[data-type="add-to-cart-form"]')) return;

        var productInfo = form.closest('product-info');
        if (!productInfo?.querySelector('[data-iw-purchase-type], [data-iw-selling-plan-input]')) return;

        syncSellingPlanInput(productInfo, form);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.product-form__submit');
        if (!button) return;

        var form = button.closest('product-form')?.querySelector('form[data-type="add-to-cart-form"]');
        var productInfo = form?.closest('product-info');
        if (!productInfo?.querySelector('[data-iw-purchase-type], [data-iw-selling-plan-input], .product-form__input--card')) return;

        syncSellingPlanInput(productInfo, form);
      },
      true
    );
  }

  function bindProductInfo(productInfo) {
    if (!productInfo || productInfo.dataset.iwVariantCardsBound === 'true') return;
    if (!productInfo.querySelector('[data-iw-purchase-type], [data-iw-selling-plan-input], .product-form__input--card')) return;

    productInfo.dataset.iwVariantCardsBound = 'true';
    bindCartFormSubmit(productInfo);
    bindLocalVariantInputs(productInfo);

    productInfo.addEventListener('change', function (event) {
      if (event.target.closest('[data-iw-purchase-type]')) {
        refreshPurchaseState(productInfo);
        return;
      }

      if (isOnetimeOnlySection(productInfo) || productInfo.hasAttribute('data-iw-static-variants')) return;

      if (event.target.closest('.iw-variant-card input[type="radio"]')) {
        refreshPurchaseState(productInfo);
      }
    });

    productInfo.querySelectorAll('[data-iw-purchase-type] input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        refreshPurchaseState(productInfo);
      });
    });

    refreshPurchaseState(productInfo);
  }

  var neutralizeSellingPlanTimer;

  function scheduleNeutralizeForeignSellingPlanInputs() {
    clearTimeout(neutralizeSellingPlanTimer);
    neutralizeSellingPlanTimer = setTimeout(function () {
      neutralizeForeignSellingPlanInputs();
    }, 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindGlobalSubmit();
    document.querySelectorAll('product-info').forEach(bindProductInfo);
    neutralizeForeignSellingPlanInputs();

    if (!window.iwSellingPlanObserverBound) {
      window.iwSellingPlanObserverBound = true;
      var observer = new MutationObserver(function () {
        scheduleNeutralizeForeignSellingPlanInputs();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  });

  document.addEventListener('product-info:loaded', function (event) {
    bindProductInfo(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (_ref) {
      var sectionId = _ref.data.sectionId;
      var productInfo = document.querySelector('product-info[data-section="' + sectionId + '"]');
      if (!productInfo || isOnetimeOnlySection(productInfo) || productInfo.hasAttribute('data-iw-static-variants')) return;

      requestAnimationFrame(function () {
        refreshPurchaseState(productInfo);
      });
    });
  }
})();
